import API from '../../../api/API';
import { createMatchData } from '../utils/matchUtils';

export const useMatchAPI = () => {

  // Le due distinte piu' il punteggio, in una chiamata sola. Prima servivano due chiamate, e la
  // prima si portava dietro tutte le squadre dell'edizione coi loghi in base64.
  const caricaCoppia = async (s1Id, s2Id, tipo = null, nome = null) => {
    try {
      const response = await API.partite.editor(s1Id, s2Id, tipo, nome);

      if (!response || !response.isSuccess || !response.data) {
        return null;
      }

      return response.data;
    } catch (error) {
      console.error('Errore nella chiamata API partite.editor:', error);
      return null;
    }
  };

  const salvaPartita = async (formData) => {
    try {      
      const partitaData = createMatchData(
        formData.isEditMode,
        formData.partitaCorrente,
        formData.edizioneSelezionata,
        formData.squadra1,
        formData.squadra2,
        formData.giocatoriSquadra1,
        formData.giocatoriSquadra2,
        formData.falli1,
        formData.falli2,
        formData.fairPlay1,
        formData.fairPlay2,
        formData.tipoPartita,
        formData.fasciaPartita,
        formData.nome
      );
      let response;
      if (formData.isEditMode) {
        response = await API.partite.update(partitaData);
      } else {
        response = await API.partite.create(partitaData);
      }


      if (response && response.isSuccess) {
        return {
          success: true,
          data: response.data,
          message: formData.isEditMode ? 'Partita aggiornata con successo!' : 'Partita salvata con successo!'
        };
      } else {
        console.error('API call failed:', response);
        return {
          success: false,
          message: `Errore durante il salvataggio della partita: ${response?.errorMsg || 'Unknown error'}`
        };
      }
    } catch (error) {
      console.error('Errore durante il salvataggio:', error);
      return {
        success: false,
        message: 'Errore durante il salvataggio della partita'
      };
    }
  };

  return {
    caricaCoppia,
    salvaPartita
  };
};